import { render, staticRenderFns } from "./doctor-canvas-poster.vue?vue&type=template&id=70bdbc5e&scoped=true"
import script from "./doctor-canvas-poster.vue?vue&type=script&lang=js"
export * from "./doctor-canvas-poster.vue?vue&type=script&lang=js"
import style0 from "./doctor-canvas-poster.vue?vue&type=style&index=0&id=70bdbc5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bdbc5e",
  null
  
)

export default component.exports